var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"leftPane hidden-xs-only"}),_c('v-col',{attrs:{"lg":"5","md":"7","sm":"10","xl":"4","xs":"12"}},[_c('v-slide-x-reverse-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)],1),_c('AppMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }